/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Audio_S3Inputs */

const en_tut_audio_s3 = /** @type {(inputs: Tut_Audio_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For quick text, press **Ikuti chat sekitar** in the sidebar, type, and press **Kirim**.`)
};

const id_tut_audio_s3 = /** @type {(inputs: Tut_Audio_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk teks singkat, tekan **Ikuti chat sekitar** di sidebar, tulis pesan, lalu **Kirim**.`)
};

/**
* | output |
* | --- |
* | "For quick text, press **Ikuti chat sekitar** in the sidebar, type, and press **Kirim**." |
*
* @param {Tut_Audio_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_audio_s3 = /** @type {((inputs?: Tut_Audio_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Audio_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_audio_s3(inputs)
	return en_tut_audio_s3(inputs)
});